import { getWindowLocationValues } from './helpers'

/**
 * Track form leave events
 *
 * @param {object} statsigClient
 * @param {object} event
 * @param {string} event.fromStepId
 * @param {object} event.scope
 */
export function trackFormLeaveEvent(statsigClient, { fromStepId, scope }) {
  statsigClient?.logEvent('form_leave', fromStepId, {
    from_step_id: fromStepId,
    form_id: scope?.form_id,
    form_entry_point: scope?.form_entry_point,
    ...getWindowLocationValues(scope),
  })
}
